import { InputNumber as AntInputNumber } from "antd";
import type { InputNumberProps as AntInputNumberProps } from "antd";

interface CustomInputNumberProps extends AntInputNumberProps {
  label?: string;
  error?: string;
  labelClassName?: string;
}

export function InputNumber({ label, error, labelClassName, ...props }: CustomInputNumberProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <AntInputNumber
        status={error ? "error" : undefined}
        className="w-full"
        {...props}
      />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
